<template>
    <div class="form-control" :class="class">
        <label
            v-if="label"
            :for="id"
            class="form-label"
        >
            {{ label }}:
        </label>

        <input
            :id="id"
            class="form-input"
            :class="{ error }"
            @input="$emit('update:modelValue', $event.target.value)"
            :value="modelValue"
            ref="input"
            :type="type"
            v-bind="$attrs"
        >

        <small
            v-if="help"
            class="form-help"
        >
            {{ help }}
        </small>

        <small
            v-if="errorMessage && error"
            class="form-error"
        >
            {{ error }}
        </small>
    </div>
</template>

<script>
import useId from '@/functions/useId'

export default {
    inheritAttrs: false,
    props: {
        modelValue: [String, Number],
        label: {
            type: String,
        },
        type: {
            type: String,
            default: 'text'
        },
        class: String,
        help: {
            type: String,
        },
        error: {
            type: String,
            default: ''
        },
        errorMessage: {
            type: Boolean,
            default: true,
        }
    },
    emits: ['update:modelValue'],
    computed: {
        id() {
            return useId(this.label);
        },
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
    }
}
</script>
